import * as TabsPrimitive from "@radix-ui/react-tabs";
import { cn } from "@/lib/utils";

export const Tabs = TabsPrimitive.Root;
export const TabsContent = TabsPrimitive.Content;

export function TabsList({ className, ...props }: TabsPrimitive.TabsListProps) {
  return (
    <TabsPrimitive.List
      className={cn(
        "mb-5 inline-flex items-center gap-1 rounded-lg border bg-bg-secondary p-1",
        className,
      )}
      style={{ borderColor: "var(--accent-subtle)" }}
      {...props}
    />
  );
}

export function TabsTrigger({ className, ...props }: TabsPrimitive.TabsTriggerProps) {
  return (
    <TabsPrimitive.Trigger
      className={cn(
        "rounded-md px-4 py-1.5 text-sm font-medium text-text-secondary transition data-[state=active]:bg-accent data-[state=active]:text-on-accent hover:text-text",
        className,
      )}
      {...props}
    />
  );
}
